import React, { useState } from "react";
import Login from "../LoginForm/LoginForm";
import Signup from "../SignUp/Signup";
import "../../../assests/css/customer/Customerlogin.css";

const Customerlogin = () => {
  const [activeForm, setActiveForm] = useState("login");

  return (
    <div className="CustomerLoginForm">
      {activeForm === "login" ? (
        <Login onSwitchToSignup={() => setActiveForm("signup")} />
      ) : (
        <Signup onSwitchToLogin={() => setActiveForm("login")} />
      )}
    </div>
  );
};

export default Customerlogin;